import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/app')({
  beforeLoad: async () => {
    // /app is a SPA experience. Guard client-side via Supabase session.
    if (typeof window === 'undefined') return;

    const { supabase } = await import('@upcaret/supabase-types/client');
    const { data, error } = await supabase.auth.getSession();

    if (error || !data.session?.user) {
      const redirectTo = `${window.location.pathname}${window.location.search ?? ''}`;
      throw redirect({
        to: '/auth/sign-in',
        // Search schema is defined by /auth/sign-in route.
        search: () => ({ redirect: redirectTo }),
      });
    }
  },
});
